import { globalModalsZIndex } from "@smartsuite/react-ui/lib/constants/zIndex";
import cx from "classnames";
import React, { useState, useImperativeHandle } from "react";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";
import { isPopupsEnabled } from "../../popups-enabled-plugin";
export const EditorPopup = ({ view, referenceElement, placement = "top-start", offsetTop = 0, offsetLeft = 0, boundaryPadding = 48, flipEnabled = false, preventOverFlowEnabled = true, visibleWhenEditorUnfocused = false, zIndex = globalModalsZIndex, actionsRef, children, }) => {
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes, update, forceUpdate } = usePopper(referenceElement, popperElement, {
        placement,
        modifiers: [
            { name: "offset", options: { offset: [offsetLeft, offsetTop] } },
            { name: "flip", enabled: flipEnabled },
            {
                name: "preventOverflow",
                enabled: preventOverFlowEnabled,
                options: {
                    altBoundary: true,
                    altAxis: true,
                    padding: {
                        top: -boundaryPadding,
                        bottom: -boundaryPadding,
                    },
                },
            },
        ],
    });
    useImperativeHandle(actionsRef, () => ({
        update,
        forceUpdate,
    }));
    return createPortal(React.createElement("div", { ref: setPopperElement, className: cx("editor-popup", {
            "editor-popup--hidden": !visibleWhenEditorUnfocused && !isPopupsEnabled(view.state),
        }), "id-exclude-click-outside": "true", 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0, style: { zIndex, ...styles.popper }, ...attributes.popper }, children), document.body);
};
